/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 jQuery(document).ready(function () {
  if (jQuery('.gallery-main').length) {
    var galleryTop = new Swiper('.gallery-main', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      loop: true,
      loopedSlides: 4,

    });
    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      centeredSlides: true,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      direction: 'vertical',
      slideToClickedSlide: true,
      loop: true,
      loopedSlides: 4
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
  }
  if (jQuery('.SizeSwatchList').length) {
    jQuery('.SizeSwatchList').on('click', 'label', function () {
      jQuery('.SizeSwatchList label').removeClass('active');
      jQuery(this).addClass('active');
    })
  }


   function initCollectionListCarousel() {

        if(window.innerWidth > 991 ) {
          jQuery('.CollectionList-Carousel').flickity({
            // options
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            contain: true,
            cellAlign: "center",
            dragThreshold: 3,
            groupCells: 1,
            arrowShape: `M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853
            0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183
            L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333
            L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203
            L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003
            C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493`
              
          });
        } else {
          jQuery('.CollectionList-Carousel').addClass('carouselDisabled');
          jQuery('.CollectionList-Carousel').removeClass('wrap');
        }
    
        window.addEventListener('resize', () => {
          if(window.innerWidth < 991 ) {
            jQuery('.CollectionList-Carousel').addClass('carouselDisabled');
            jQuery('.CollectionList-Carousel').removeClass('wrap');
            jQuery('.CollectionList-Carousel').flickity('destroy');
          } else {
            jQuery('.CollectionList-Carousel').flickity({
              // options
              prevNextButtons: true,
              pageDots: false,
              wrapAround: true,
              contain: true,
              cellAlign: "center",
              dragThreshold: 3,
              groupCells: 1,
              arrowShape: `M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853
              0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183
              L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333
              L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203
              L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003
              C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493`
            });
            jQuery('.CollectionList-Carousel').removeClass('carouselDisabled');
            jQuery('.CollectionList-Carousel').addClass('wrap');
          }
        })
  };
  if(jQuery('.CollectionList-Carousel').length) {
    initCollectionListCarousel();
  }

  function initProductListCarousel() {
    jQuery('.ProductList-Carousel').flickity({
      // options
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      contain: true,
      cellAlign: "left",
      dragThreshold: 1,
      groupCells: true,
      arrowShape:  "M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853 0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183 L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333 L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203 L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003 C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493"      
    })
  }
  if( jQuery('.ProductList-Carousel').length ) {
    initProductListCarousel()
  }

  if (Shopify.designMode) {
     document.addEventListener('shopify:section:load', function(event) {
      if(jQuery('.CollectionList-Carousel').length) {
        initCollectionListCarousel();
      }
      if( jQuery('.ProductList-Carousel').length ) {
        initProductListCarousel()
      }
    });
  } 
   
  if(jQuery('#productRecommendations').length) {
    var checkCarouselProductRecommendations = setInterval(function(){ 
      if( jQuery('.ProductList-Carousel--productRecommendations').length ) {
          jQuery('.ProductList-Carousel--productRecommendations').flickity({
            // options
            prevNextButtons: true,
            pageDots: true,
            wrapAround: true,
            contain: true,
            cellAlign: "left",
            dragThreshold: 1,
            groupCells: true,
            arrowShape:  "M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853 0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183 L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333 L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203 L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003 C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493"      
          })
          clearInterval(checkCarouselProductRecommendations);
        }
      }, 100); // check after 10ms every time
  }
  if(jQuery('#recentlyViewedProducts').length) {
    var checkCarouselRecentlyViewedProducts = setInterval(function(){ 
      if( jQuery('.ProductList-Carousel--recentlyViewedProducts').length ) {
          if(jQuery('.ProductList-Carousel--recentlyViewedProducts .product-card').length >= 4) {
            jQuery('.ProductList-Carousel--recentlyViewedProducts').flickity({
              // options
              prevNextButtons: true,
              pageDots: true,
              wrapAround: true,
              contain: true,
              cellAlign: "left",
              dragThreshold: 1,
              groupCells: true,
              arrowShape:  "M0.541,32.7493 C0.526,32.7843 0.521,32.8213 0.507,32.8563 C0.189,33.6663 0,34.5413 0,35.4633 C0,36.3853 0.189,37.2603 0.507,38.0693 C0.521,38.1043 0.526,38.1423 0.541,38.1773 C0.904,39.0593 1.433,39.8533 2.097,40.5183 L30.413,68.8333 C33.203,71.6243 37.723,71.6243 40.513,68.8333 C43.304,66.0433 43.304,61.5233 40.513,58.7333 L24.386,42.6053 L92.857,42.6053 C96.803,42.6053 100,39.4063 100,35.4633 C100,31.5203 96.803,28.3203 92.857,28.3203 L24.386,28.3203 L40.513,12.1923 C43.304,9.4023 43.304,4.8833 40.513,2.0933 C39.118,0.6973 37.291,0.0003 35.463,0.0003 C33.636,0.0003 31.808,0.6973 30.413,2.0933 L2.097,30.4083 C1.433,31.0723 0.904,31.8673 0.541,32.7493"      
            })
          }
          clearInterval(checkCarouselRecentlyViewedProducts);
        }
      }, 100); // check after 10ms every time
  }
  // Auto scrolling for product tabs.

  if(jQuery('.product-info .accordion .accordion__toggle').length) {
    function openFirstProductTab() { 
      let firstTab = jQuery('.product-info .accordion .accordion__toggle')[0];
      if (firstTab.length === 0)
        return;
      firstTab.click();
    } 
    openFirstProductTab()
  }



// Coyaka-upsell-progress-bar

// function coyakaSize() {
//   console.log("change change")
// }
// coyakaSize()

// new ResizeObserver(coyakaSize).observe("coyaka-upsell-progress-bar")

// jQuery(document).ready(function () {
//   setTimeout(function () {
//     var coyakaUpsellProgressBarHeight = document.getElementById("coyaka-upsell-progress-bar").clientHeight;
//     document.documentElement.style.setProperty('--coyaka-upsell-progress-bar-maxHeight', coyakaUpsellProgressBarHeight + 'px');
//     console.log("ok2", coyakaUpsellProgressBarHeight);
//   }, 500)
// })


// Klaviyo Popup


  var timeDelay = 8000;
  const showOverlay = () => jQuery("#modal-contact-dark-overlay") ? jQuery("#modal-contact-dark-overlay").show() : null 
  const showModal = () => jQuery("#contact-modal-container") ? jQuery("#contact-modal-container").show() : null
  const hideOverlay = () => jQuery("#modal-contact-dark-overlay") ? jQuery("#modal-contact-dark-overlay").hide() : null
  const hideModal = () => jQuery("#contact-modal-container") ? jQuery("#contact-modal-container").hide() : null

  const myPopup = setTimeout(function () {
    showOverlay();
    showModal();
  }, timeDelay)
  if(document.getElementById('form')) {
    document.getElementById('form').addEventListener('submit', function (event) {
      event.preventDefault();

      const serviceID = 'default_service';
      const templateID = 'template_xxxxx';

      emailjs.sendForm(serviceID, templateID, this).then(() => {
        alert('Sent!');
        hideOverlay();
        hideModal();
      },
        (err) => {
          alert(JSON.stringify(err));
        });
    });
  }


  // Close the Modal Window by clicking the X
  if(document.getElementById("contact-modal-exit"))  {
    document.getElementById("contact-modal-exit").onclick = function () {
      hideOverlay();
      hideModal();
    }
  }
  if(document.getElementById("optOut")){
    document.getElementById("optOut").onclick = function () {
      hideOverlay();
      hideModal();
    }
  }
  if(document.getElementById("parfum_CheckoutButtonBanner")) {
    document.getElementById("parfum_CheckoutButtonBanner").onclick = function () {
      showOverlay();
      showModal();
      clearTimeout(myPopup);
    }
  }
  if(document.getElementById("parfum_CheckoutButtonFooter")) {
    document.getElementById("parfum_CheckoutButtonFooter").onclick = function () {
      showOverlay();
      showModal();
      clearTimeout(myPopup);
    }
  }
});

